import { Method } from "axios";
import { apiKey } from "../constants/urls";

export type FetchFunction = (
  url: string,
  method?: Method,
  data?: BodyInit | null,
  headers?: HeadersInit
) => Promise<any>;

export const createSearchParams = () => {
  const searchParams = new URLSearchParams();
  searchParams.append("api_key", apiKey);
  return searchParams;
};
